<div class="multiselect-row">
  <div class="multiselect-row__selected-items">
    <ocp-icon-label
      iconSrc="cross.svg"
      [label]="(selectedItems() ?? 0) + ' ' + ('multiselect-row.selected' | translate)"
      (iconClick)="deselectClick.emit()"
    />
  </div>
  <ng-template #selectorControl let-selector let-menu="menu">
    @if (menu) {
      <button
        type="button"
        class="multiselect-row__menu-action"
        (click)="onCompactActionClick(selector)"
      >
        @if (selector.imgSrc; as imgSrc) {
          <ocp-themed-icon class="multiselect-row__menu-action-icon" [name]="imgSrc" [size]="16" />
        }
        {{ selector.label }}
      </button>
    } @else {
      <ocp-icon-label [iconSrc]="selector.imgSrc ?? ''" [label]="selector.label + ':'" />
      <hlm-select
        class="flex-1 min-w-0 multiselect-row__hlm-select"
        [value]="selectedValues()[selector.id]"
        (valueChange)="onChange(selector.id, $event)"
      >
        <hlm-select-trigger
          class="multiselect-row__select-trigger w-full"
          variant="surface-secondary"
        >
          <hlm-select-value [placeholder]="selector.placeholder" />
        </hlm-select-trigger>
        <hlm-select-content *hlmSelectPortal class="w-auto min-w-full" variant="surface-secondary">
          <hlm-select-group>
            @for (option of selector.value; track $index) {
              <hlm-select-item
                [value]="option"
                class="multiselect-row__select-item whitespace-nowrap"
                variant="surface-secondary"
                >{{ $any(option)?.label ?? option }}</hlm-select-item
              >
            }
          </hlm-select-group>
        </hlm-select-content>
      </hlm-select>
    }
  </ng-template>

  @if (!compact()) {
    <div class="multiselect-row__selectors" #selectorsContainer>
      @for (selector of selectors(); track selector.id) {
        <div class="multiselect-row__selector">
          <ng-container *ngTemplateOutlet="selectorControl; context: { $implicit: selector }" />
        </div>
      }
    </div>
  }
  <div class="multiselect-row__actions">
    <ng-content />
  </div>

  @if (menuSelectors().length) {
    <hlm-popover
      align="end"
      [state]="dropdownMenuState()"
      (stateChanged)="dropdownMenuState.set($event)"
    >
      <button
        hlmPopoverTrigger
        type="button"
        class="table-row-actions__btn"
        [attr.aria-label]="'menu'"
      >
        <ocp-themed-icon name="three-dots.svg" [size]="18" />
      </button>
      <hlm-popover-content *hlmPopoverPortal class="multiselect-row__menu-content">
        <div class="table-row-actions__menu">
          @for (item of menuSelectors(); track item.id) {
            <div class="multiselect-row__selector multiselect-row__selector--menu">
              <ng-container
                *ngTemplateOutlet="selectorControl; context: { $implicit: item, menu: true }"
              />
            </div>
          }
        </div>
      </hlm-popover-content>
    </hlm-popover>
  }
</div>
